import React, { useCallback } from 'react';
import { FileError, useDropzone } from 'react-dropzone';
import { Anchor, Box, FileCheckIcon, Text } from '@common-fe/common-fe';

import { ACCEPTED_FILE_TYPES, FileImage, MAX_SIZE_OF_FILE } from '@/common/constants';
import prepareFile from '@/components/elements/DropScan/prepareFile';
import useFilesInDocumentStore from '@/components/elements/DropScan/useFilesInDocument.store';
import useOnDrop from '@/components/elements/DropScan/useOnDrop';

interface Props {
  isViewMode?: boolean;
  onFileUploadError?: (error?: FileError) => void;
  storeKey?: string;
}

const ChangeFile: React.FC<Props> = ({ isViewMode, onFileUploadError, storeKey  }) => {
  const { values, handleSetValues } = useFilesInDocumentStore(storeKey);
  const onFilesAdded = useCallback(
    (acceptedFiles: FileImage[]) => {
      if (acceptedFiles?.length) {
        handleSetValues({ files: acceptedFiles.map(prepareFile) });
      }
    },
    [handleSetValues]
  );

  const { onDrop } = useOnDrop({ onFilesAdded, onFileUploadError, disableFilesUpload: true, storeKey });
  const { getInputProps, open } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    maxSize: MAX_SIZE_OF_FILE,
    onDrop,
    noDrag: true,
    noClick: true,
    multiple: false,
    maxFiles: 1,
  });

  return (
    <Box
      data-testId="change-file"
      pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}
      align="center"
      justify="between"
      direction="row"
      background="canvas"
      round="container2Round"
      border={{ color: 'border2', size: '1px' }}
    >
      <Box direction="row" align="center" data-testId="change-file_name">
        <Box
          round="button2Round"
          border={{ color: 'border2' }}
          pad="spacing4"
          margin={{ right: 'spacing12' }}
          width={{ min: 'auto' }}
        >
          <FileCheckIcon color="iconPrimary" />
        </Box>
        <Text wordBreak="break-all">{values?.files?.[0]?.name}</Text>
      </Box>

      {isViewMode ? null : (
        <>
          <Anchor data-testId="change-file_button" size="medium" weight={400} onClick={open}>
            Change file
          </Anchor>

          <input {...getInputProps()} />
        </>
      )}
    </Box>
  );
};

export default ChangeFile;
